export default __webpack_public_path__ + "static/media/j4.4f82893b.jpg";